import { frontendURL } from 'dashboard/helper/URLHelper.js';

import SalesAssistRouteView from './pages/SalesAssistRouteView.vue';
import SalesAssistPage from './pages/SalesAssistPage.vue';

const meta = {
  permissions: ['administrator', 'agent', 'manager'],
};

const salesAssistRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/sales-assist'),
      component: SalesAssistRouteView,
      children: [
        {
          path: '',
          name: 'sales_assist_index',
          meta,
          component: SalesAssistPage,
        },
        {
          path: ':conversation_id',
          name: 'sales_assist_conversation',
          meta,
          component: SalesAssistPage,
          props: route => ({
            conversationId: route.params.conversation_id,
          }),
        },
      ],
    },
  ],
};

export default salesAssistRoutes;
